export default __webpack_public_path__ + "static/media/1263.75f568bd.png";